import React from 'react'
import { CircularProgress } from '@mui/material'

import SettingsFooter from './shared/SettingsFooter'
import ListEditor from '../common/ListEditor'
import useContactTypes from '../hooks/api/useContactTypes'

import useAlert from '../hooks/useAlert'
import DragAndDropInstructions from './shared/DragAndDropInstructions'

// TECH-DEBT: for these lists with max lengths, handle that in the hook maybe? (future me: I'm not sure what this meant)
const MAX_ALLOWED_CONTACT_TYPES = 20

export const ContactTypesForm = ({ contactTypes, setContactTypes }) => {
  return (
    <ListEditor
      list={contactTypes}
      editableKeys={[{ label: 'Contact Type', key: 'name' }]}
      onChange={setContactTypes}
      maxLength={MAX_ALLOWED_CONTACT_TYPES}
      canReorder
    />
  )
}

const ContactTypes = () => {
  const { contactTypes, setContactTypes, saveContactTypes, isLoading } =
    useContactTypes()

  const { createAlert, createGenericErrorAlert } = useAlert()
  const onSuccess = () =>
    createAlert({
      severity: 'success',
      message: 'Successfully saved contact types',
    })

  const onFailure = () => createGenericErrorAlert()

  const submit = () => {
    return saveContactTypes().then(onSuccess).catch(onFailure)
  }

  if (isLoading) return <CircularProgress />

  return (
    <>
      <DragAndDropInstructions sx={{ mb: 3 }} />
      <ContactTypesForm
        contactTypes={contactTypes}
        setContactTypes={setContactTypes}
      />
      <SettingsFooter saveButton={{ onClick: submit }} />
    </>
  )
}

export default ContactTypes
